import { Component, Inject, Output, PLATFORM_ID } from '@angular/core';
import { BookModel, KissatiService } from '../../services/kissati.service';
import { CommonModule } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import {
  ChildrenSelectorComponent,
  Student,
} from '../../shared/children-selector/children-selector.component';
import { finalize, switchMap } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../shared/loader/loader.component';
interface UserData {
  iduser: number;
  role: number;
  idTeacher: number;
  orgid: number;
  testmobile: number;
  error?: string;
  listStudent?: Student[];
}
@Component({
  selector: 'app-kissati',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ChildrenSelectorComponent,
    TranslatePipe,
    LoaderComponent,
  ],
  templateUrl: './kissati.component.html',
  styleUrl: './kissati.component.css',
})
export class KissatiComponent {
  books: BookModel[] = [];
  isLoading = false;
  error: string | null = null;
  students: Student[] = [];
  @Output() selectedStudent: Student | null = null;
  currentPage = 1;
  pageSize = 10;
  totalPages = 1;
  userData: UserData | null = null;
  searchValue: string = '';
  @Output() selectedStudentId: number | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private kissatiService: KissatiService,
    private router: Router
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const userDataStr = localStorage.getItem('userData');
      const studentListStr = localStorage.getItem('studentList');

      if (userDataStr) {
        try {
          this.userData = JSON.parse(userDataStr);
        } catch (e) {
          console.error('Failed to parse userData', e);
        }
      }

      if (studentListStr) {
        try {
          this.students = JSON.parse(studentListStr);
          if (this.students.length > 0 && !this.selectedStudent) {
            this.selectedStudent = this.students[0];
            this.loadStudentBooks(this.selectedStudent, 1);
          } else if (this.students.length === 0) {
            this.error = 'Aucun élève sélectionné.';
          }
        } catch (e) {
          console.error('Failed to parse studentList', e);
          this.error = 'Impossible de charger les élèves.';
        }
      } else {
        this.error = 'Aucun élève sélectionné.';
      }
    }
  }

  onStudentSelected(student: Student) {
    this.selectedStudent = student;
    this.currentPage = 1;
    this.loadStudentBooks(student, 1);
  }

  onStudentsLoaded(students: Student[]) {
    this.students = students;

    if (students.length > 0 && !this.selectedStudent) {
      this.selectedStudent = students[0];
      this.loadStudentBooks(students[0], 1);
    } else if (students.length === 0) {
      this.error = 'Aucun élève sélectionné.';
      this.isLoading = false;
    }
  }

  loadStudentBooks(student: Student, page: number) {
    this.isLoading = true;
    this.error = null;

    if (!student) {
      this.error = 'Aucun élève sélectionné.';
      this.isLoading = false;
      return;
    }

    this.kissatiService
      .getDigiref(student.gradeId)
      .pipe(
        switchMap((digiref: number) => {
          return this.kissatiService.getBooksByDigiref(
            digiref,
            page,
            this.pageSize
          );
        }),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (response: any) => {
          this.books = response.listBookModel || [];
          this.totalPages = response.totalPages || 1;
          this.currentPage = page;
        },
        error: (err) => {
          this.error = 'Impossible de charger les livres.';
          console.error('Erreur lors du chargement des livres', err);
        },
      });
  }

  get pageNumbers(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  goToPage(page: number) {
    if (this.isLoading || page < 1 || page > this.totalPages) return;
    this.loadStudentBooks(this.selectedStudent!, page);
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.goToPage(this.currentPage - 1);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.goToPage(this.currentPage + 1);
    }
  }

  onSearch() {
    if (!this.selectedStudent) {
      this.error = 'Aucun élève sélectionné.';
      return;
    }

    if (!this.searchValue || this.searchValue.trim() === '') {
      this.loadStudentBooks(this.selectedStudent, 1);
      return;
    }

    this.isLoading = true;
    this.error = null;

    this.kissatiService
      .getDigiref(this.selectedStudent.gradeId)
      .pipe(
        switchMap((digiref: number) =>
          this.kissatiService.searchBooks(digiref, this.searchValue)
        ),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (response: any) => {
          this.books = response || [];
          this.totalPages = Math.ceil(this.books.length / this.pageSize);
          this.currentPage = 1;
        },
        error: (err) => {
          this.error = 'Erreur lors de la recherche.';
          console.error('Erreur recherche :', err);
        },
      });
  }

  goToBook(id: number): void {
    this.router.navigate(['/readkissati', id]);
  }
}
